import { render } from "./WixtarTicketMultiSelect.vue?vue&type=template&id=6f7dd4aa&scoped=true"
import script from "./WixtarTicketMultiSelect.vue?vue&type=script&lang=js"
export * from "./WixtarTicketMultiSelect.vue?vue&type=script&lang=js"

import "./WixtarTicketMultiSelect.vue?vue&type=style&index=0&id=6f7dd4aa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7dd4aa"]])

export default __exports__